var _path, _path2, _rect, _ellipse, _rect2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGift(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 138,
    height: 138,
    viewBox: "0 0 138 138",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M106 85L120.722 110.5H91.2776L106 85Z",
    fill: "#F50707"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M81 77L85.2658 90.1287H99.0701L87.9022 98.2426L92.1679 111.371L81 103.257L69.8321 111.371L74.0978 98.2426L62.9299 90.1287H76.7342L81 77Z",
    fill: "#E6A500"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 83,
    width: 28,
    height: 28,
    rx: 3,
    fill: "#10ABB5"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 56,
    cy: 102.5,
    rx: 13,
    ry: 13.5,
    fill: "#A247FC"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 51,
    y: 60,
    width: 35,
    height: 78,
    fill: "#81B1AA"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M129.375 60.375V125.062C129.375 128.494 128.012 131.784 125.586 134.211C123.159 136.637 119.869 138 116.438 138H77.625V60.375H129.375ZM21.5625 138C18.1313 138 14.8406 136.637 12.4143 134.211C9.98805 131.784 8.625 128.494 8.625 125.062V60.375H60.375V138H21.5625Z",
    fill: "#4E7E77"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M25.875 30.5625C25.875 24.8438 28.1468 19.3593 32.1905 15.3155C36.2343 11.2718 41.7188 9 47.4375 9C53.1562 9 58.6407 11.2718 62.6845 15.3155C66.7282 19.3593 69 24.8438 69 30.5625C69 24.8438 71.2718 19.3593 75.3155 15.3155C79.3593 11.2718 84.8438 9 90.5625 9C96.2812 9 101.766 11.2718 105.809 15.3155C109.853 19.3593 112.125 24.8438 112.125 30.5625V30.6143C112.125 31.218 112.125 32.943 111.797 34.875H129.375C131.662 34.875 133.856 35.7837 135.474 37.4012C137.091 39.0187 138 41.2125 138 43.5V52.125C138 54.4125 137.091 56.6063 135.474 58.2238C133.856 59.8413 131.662 60.75 129.375 60.75H8.625C6.33751 60.75 4.14371 59.8413 2.5262 58.2238C0.908703 56.6063 0 54.4125 0 52.125V43.5C0 41.2125 0.908703 39.0187 2.5262 37.4012C4.14371 35.7837 6.33751 34.875 8.625 34.875H26.2028C25.9749 33.4664 25.8653 32.0412 25.875 30.6143V30.5625ZM35.0865 34.875H60.375V30.5625C60.375 28.8635 60.0404 27.1812 59.3902 25.6115C58.74 24.0419 57.7871 22.6157 56.5857 21.4143C55.3843 20.2129 53.9581 19.26 52.3885 18.6098C50.8188 17.9596 49.1365 17.625 47.4375 17.625C45.7385 17.625 44.0562 17.9596 42.4865 18.6098C40.9169 19.26 39.4907 20.2129 38.2893 21.4143C37.0879 22.6157 36.135 24.0419 35.4848 25.6115C34.8346 27.1812 34.5 28.8635 34.5 30.5625C34.5 31.2956 34.5173 32.9258 34.8881 34.2712C34.9399 34.4769 35.0062 34.6787 35.0865 34.875ZM77.625 34.875H102.913C102.993 34.6783 103.059 34.4766 103.112 34.2712C103.483 32.9258 103.5 31.2956 103.5 30.5625C103.5 27.1313 102.137 23.8406 99.7107 21.4143C97.2844 18.9881 93.9937 17.625 90.5625 17.625C87.1313 17.625 83.8406 18.9881 81.4143 21.4143C78.9881 23.8406 77.625 27.1313 77.625 30.5625V34.875Z",
    fill: "#34544F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGift);
export default __webpack_public_path__ + "static/media/gift.cbc38e7594601eda1673c2b9ad0ac049.svg";
export { ForwardRef as ReactComponent };